import { render, staticRenderFns } from "./QuestionarioPrestazione.vue?vue&type=template&id=5b0fea4a&"
import script from "./QuestionarioPrestazione.vue?vue&type=script&lang=js&"
export * from "./QuestionarioPrestazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports